import { parse, extract, stringify } from 'query-string';
import { ASSET_TYPE } from '../constants/Constants';
export class AssetViewerItem {
    constructor(displayName, type, downloadUrl, previewUrl, presentations, 
    // @ts-ignore
    extension, id, annotations, // page is 0-based
    page, // page is 1-based
    position, // Only used for shares (logging showcase-client)
    isDownloadable, embeddedData, pageRanges, // page range is 1-based
    annotationVersions, canRenderInIframe, assetDescription, canPresentInOfficeOnline, assetFileId) {
        this.displayName = displayName;
        this.type = type;
        this.downloadUrl = downloadUrl;
        this.previewUrl = previewUrl;
        this.presentations = presentations;
        this.extension = extension;
        this.id = id;
        this.annotations = annotations;
        this.page = page;
        this.position = position;
        this.isDownloadable = isDownloadable;
        this.embeddedData = embeddedData;
        this.pageRanges = pageRanges;
        this.annotationVersions = annotationVersions;
        this.canRenderInIframe = canRenderInIframe;
        this.assetDescription = assetDescription;
        this.canPresentInOfficeOnline = canPresentInOfficeOnline;
        this.assetFileId = assetFileId;
        this.loadPdfPromise = null;
        this.pdfLoaded = false;
        this._numViews = null;
    }
    get isPdf() {
        return !!(this.type === ASSET_TYPE.DOCUMENT && this.extension.toLocaleLowerCase() === 'pdf');
    }
    // Dirty way to override numViews in case of PDFJS
    set numViews(number) {
        this._numViews = this.page ? 1 : number;
    }
    get numViews() {
        if (this._numViews) {
            return this._numViews;
        }
        if (!this.page && this.type === ASSET_TYPE.DOCUMENT && this.presentations && this.presentations.length) {
            const numberOfPagesArray = this.presentations
                .map((presentation) => {
                const urls = presentation.urls;
                return ((presentation.details && presentation.details.numpages) || // Total amount of pages
                    presentation.numberOfPages || // Total amount of variations (changes while processing)
                    (urls && Object.keys(urls).length));
            })
                .filter(number => !isNaN(number));
            return Math.max(...numberOfPagesArray);
        }
        else {
            return 1;
        }
    }
    loadPdf(options) {
        if (!this.loadPdfPromise) {
            this.loadPdfPromise = window.pdfjsLib.getDocument(options).promise;
            this.loadPdfPromise.catch(error => {
                if (error && error.status === 401) {
                    this.loadPdfPromise = null;
                }
                throw error;
            });
        }
        return this.loadPdfPromise;
    }
    loadPresentations() {
        return Promise.reject("loadPresentations() wasn't configured");
    }
    /**
     * Download a file by opening a new tab
     */
    download() {
        const urlParams = Object.assign(Object.assign({}, parse(extract(this.downloadUrl))), { filename: this.displayName });
        window.open(`${this.downloadUrl.split('?')[0]}?${stringify(urlParams)}`);
    }
}
//# sourceMappingURL=AssetViewerItem.js.map